import _ from 'lodash';

import { useEffect, useState } from 'react';
import EnvContext from './EnvContext';
import useAuthentication from '@/hooks/useAuthentication';
interface PageProps {
  children: React.ReactNode;
  configVars: any;
}

type EnvVars = {
  [key: string]: string | number | boolean | undefined;
};

  const EnvProvider = ({ children, configVars }: PageProps) => {
  const [envVars] = useState<any | null>(configVars);
  const [chatStartTimestamp, setChatStartTimestamp] = useState();
  const [customerData, setCustomerData] = useState();
  const [customerOrders, setCustomerOrders] = useState();
  const [isInIframe, setIsInIframe] = useState(false);
  const [isPartiallyAuthenticated, setIsPartiallyAuthenticated] = useState(true);

  const { authToken, setAuthToken, isAuthenticated, setHeaders, setCookies, headers, cookies } = useAuthentication();

  useEffect(() => {
    try {
      setIsInIframe(window?.self !== window?.top);
    } catch (error) {
      setIsInIframe(false);
    }
  }, [setIsInIframe]);

  return (
    <EnvContext.Provider
      value={{
        ...envVars,
        authToken,
        isAuthenticated,
        setAuthToken,
        setHeaders,
        setCookies,
        headers,
        cookies,
        chatStartTimestamp,
        setChatStartTimestamp,
        customerData,
        setCustomerData,
        customerOrders,
        setCustomerOrders,
        isPartiallyAuthenticated,
        setIsPartiallyAuthenticated,
        isInIframe,
        setIsInIframe
      }}
    >
      {children}
    </EnvContext.Provider>
  );
};

export default EnvProvider;
